import { render } from "./ClientCajasConfiguracion.vue?vue&type=template&id=1b6dfc21"
import script from "./ClientCajasConfiguracion.vue?vue&type=script&lang=js"
export * from "./ClientCajasConfiguracion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__